import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import * as auth from "../_redux/authRedux";
import {resetPassword} from "../_redux/authCrud";
import {useTranslation} from "react-i18next";

const initialValues = {
  email: "",
};

function ForgotPassword() {
  const {t} = useTranslation('common')

  const [isRequested, setIsRequested] = useState(false);
  const [okMessage, setOkMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const ForgotPasswordSchema = Yup.object().shape({
    phone: Yup.string()
    .matches(/^09[0-9]{9}$/, t("AUTH.VALIDATION.INVALID_PHONE"))
    .required(
      t('AUTH.VALIDATION.REQUIRED_FIELD')
    ),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      resetPassword(values.phone,t('lang'))
        .then(({ data}) => {
          if (data.success) {
            setStatus('')
            setOkMessage(t('SendEmailRecovery'))
          } else {
            setSubmitting(false);
            setStatus(
              data.error
            );
          }
        })
        .catch(() => {
          setIsRequested(false);
          setSubmitting(false);
          setStatus(
            t('AUTH.EMAIL.NOT_FOUND')
          );
        }).finally(()=>{
          setLoading(false)
        });
    },
  });

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">{t('ForgotPassword')}</h3>
            <div className="text-muted font-weight-bold">{t('AUTH.FORGOT.DESC')}</div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {okMessage ? (
              <div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
                <div className="alert-text font-weight-bold">{okMessage}</div>
              </div>
            ) : null}
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            {!okMessage && <div className="form-group fv-plugins-icon-container">
                <input
                  placeholder={t('AUTH.INPUT.PHONE')}
                  type="tel"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "phone"
                  )}`}
                  name="phone"
                  {...formik.getFieldProps("phone")}
                />
                {formik.touched.phone && formik.errors.phone ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.phone}</div>
                  </div>
                ) : null}
            </div>}
            <div className="form-group d-flex flex-wrap flex-center">
              {!okMessage && <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting || okMessage}
              >
                {t('PasswordRecovery')}
              </button>}
              <Link to="/auth">
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >{t('AUTH.LOGIN.BUTTON')}</button>
              </Link>
              {loading && <span className="ml-3 spinner"/>}
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default connect(null, auth.actions)(ForgotPassword)
